import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ImageCarouselComponent} from '../../component/carousel/image-carousel/app.component';
import {MaterialModule} from '../../../material.module';
import {CardsComponent} from './cards/app.component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [ImageCarouselComponent, CardsComponent],
  exports: [ImageCarouselComponent, CardsComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CarouselModule {}
